import { VBtn, VSnackbar } from "vuetify/lib";

export default {
	name: "KSiteUpdate",

	data: () => ( {
		buttonText: "Refresh",
		notificationText: "A Kinnect update is available",
		refreshing: false,
		registration: null,
		showNotification: false,
		timeout: -1
	} ),

	methods: {
		showRefresh( e ) {
			this.registration = e.detail;
			this.showNotification = true;
		},

		refreshApp() {
			this.showNotification = false;

			if ( !this.registration || !this.registration.waiting ) {
				return;
			}

			this.registration.waiting.postMessage( { type: "SKIP_WAITING" } );
		}
	},

	created() {
		document.addEventListener( "swUpdated", this.showRefresh, { once: true } );

		navigator.serviceWorker.addEventListener( "controllerchange", () => {
			if ( this.refreshing ) {
				return;
			}

			this.refreshing = true;
			window.location.reload();
		} );
	},

	render() {
		return <VSnackbar
			color="success"
			timeout={this.timeout}
			top
			vModel={this.showNotification}
			scopedSlots={{
				action: () =>
					<VBtn
						onClick={this.refreshApp}
						text
					>
						{this.buttonText}
					</VBtn>
			}}
		>
			{this.notificationText}
		</VSnackbar>;
	}
};
